const dictionary = {
    "Stemmed": [
        'Cocktail_glass',
        'Hurricane_glass',
        'Punch_bowl',
        'Irish_coffee_cup',
        'Wine_Glass',
        'Margarita/Coupette_glass',
        'Coupe_Glass',
        'Balloon_Glass',
        'Margarita_glass',
        'Martini_Glass',
        'Brandy_snifter',
        'White_wine_glass',
        'Nick_and_Nora_Glass',
        'Pousse_cafe_glass', 
        'Champagne_flute',
        'Whiskey_sour_glass',
        'Cordial_glass',
    ],
    "Stemless": [
        'Highball_glass',
        'Old-fashioned_glass', 
        'Whiskey_Glass', 
        'Collins_glass', 
        'Coffee_mug', 
        'Shot_glass', 
        'Jar', 
        'Pitcher', 
        'Pint_glass', 
        'Copper_Mug', 
        'Beer_mug', 
        'Beer_pilsner', 
        'Beer_Glass', 
        'Parfait_glass', 
        'Mason_jar',
    ],
    "Vodka": [
        "Vodka",
    ],
    "Rum": [
        "151_proof_rum",
        "Light_Rum",
        "Dark_Rum",
        "Rum",
    ],
    "Whiskey": [
        "Wild_Turkey",
        "Southern_Comfort",
        "Rye_Whiskey",
        "Irish_Whiskey",
        "Jack_Daniels",
        "Crown_Royal",
        "Bourbon",
        "Blended_Whiskey",
    ],
    "Scotch": [
        "Scotch",
        "Johnnie_Walker",
    ],
    "Gin": [
        "Gin",
    ],
    "Tequila": [
        "Tequila"
    ],
    "Carbonation": [
        "Soda_Water",
        "Tonic_Water",
        "Ginger_Ale",
        "Ginger_Beer",
        "Club_Soda",
        "Carbonated_Water",
    ],
    "Lime": [
        "Lime_Juice",
        "Lime",
    ],
    "Bitters": [
        "Bitters",
        "Orange_Bitters",
        "Angostura_Bitters",
    ],
    "Orange": [
        "Orange_Juice",
        "Orange",
    ],
    "Lemon": [
        "Lemon",
        "Lemon_Juice"
    ],
    "Coffee & Cream": [
        "Coffee",
        "Light_Cream",
        "Espresso",
        "Cream",
        "Baileys_Irish_Cream",
    ]
}

export default dictionary;